<template>
  <div class="home" style="background:white;">
    <mynav1_en :data='nvdata' ></mynav1_en>
    <div id="abhead">
      <div>About SZZT</div>
      <div>SZZT is the only company in the world that specializes in appearance design, structural design, component design and cabinet production</div>
    </div>


    <div id='abcompany' v-if="stype=='company'">
      <div id="abcptt">Company Profile</div>
      <div id="abcpct"> After more than 20-year development, SZZT has developed into a high-tech enterprise covering three business sectors of IDC and cloud computing, financial technology and lighting technology. SZZT has built 3 industrial parks in Shenzhen, Changsha and Dongguan, and has 6 large-scale Internet data centers in Shenzhen Guangming, Guangzhou Nansha, Dongguan Shijie, Dongguan Qifeng, Changsha Wangcheng and Wuhan Shenhu,with 6 R&D centers, 28 after-sales service centers and 182 after-sales service outlets in nationwide.</div>
      <div id="abcppic">
        <h5><img :src="require('@/assets/pic/about/ctpic.jpg')"/></h5>
        <div>
          <h4 v-for="item in ctpics" :key="item.label">
            <img :src="require('@/assets/pic/about/'+item.pic)"/><label>{{item.label}}</label><label>{{item.value}}</label>
          </h4>
        </div>
      </div>
      <div id="abcard">
        <div id="abcptt">SZZT Strength</div>
        <h5>With cloud computing and secure payment as the core technologies and data operation as the core driving force, SZZT has became the IDC + cloud computing service providers for cloud operators and fintech service providers for "application + scenarios".</h5>
        <h4 v-for="item in cards" :key="item.label">
          <label>{{item.label}}</label>
          <img :src="require('@/assets/pic/about/'+item.pic)" />
        </h4>
      </div>
      <div id="abcpcus">
        <h4>Customization capability for financial electronic terminal</h4>
        <h5>All-in-one customization capability & powerful differentiated services</h5>
        <div v-for="item in cpcusdata" :key="item.label">
          <label>{{item.label}}</label>
          <img :src="item.img" />
        </div>
      </div>

    </div>

    <div id="abcontact" v-else>
      <div id="abcttt">
        Office  Environment
      </div>
      <el-row id="abalb">
        <el-col :span="12">
          <img :src="require('@/assets/pic/about/ct0.jpg')" />
        </el-col>
        <el-col :span="12">
          <img :src="require('@/assets/pic/about/ct1.jpg')" />
          <img :src="require('@/assets/pic/about/ct2.jpg')" />
        </el-col>
      </el-row>
      <div id="abctmap">
        <div>Office Address</div>
        <img :src="require('@/assets/pic/about/ditu.png')" />
      </div>
      <div id="abcthost">
        <div><img class="abctlocal" :src="require('@/assets/pic/about/local.png')" />Guangming District （Headquarters）</div>
        <label>E-mail: marketing@szzt.com.cn</label>
        <label>Add: SZZT Industrial Park, No.3 Tongguan Rd, Guangming District, Shenzhen, Guangdong, China</label>
        <label>Tel: +86 0755-81728888 ext.8393</label>
      </div>
      <div id="abctcp1">
        <el-row :gutter="80">
          <el-col :span="8" v-for="item in addrs" :key="item.addr">
            <div><img class="abctlocal" :src="require('@/assets/pic/about/local.png')" />{{item.city}}</div>
            <label>{{item.addr}}</label>
          </el-col>
        </el-row>
      </div>
      <div id="abctcp2">
        <el-row :gutter="80">
          <el-col :span="8" v-for="item in addrs1" :key="item.addr">
            <div><img class="abctlocal" :src="require('@/assets/pic/about/local.png')" />{{item.city}}</div>
            <label>{{item.addr}}</label>
          </el-col>
        </el-row>
      </div>
    </div>
    <myfooter_en :data='ftdata' ></myfooter_en>
  </div>
</template>
<style>
#abctcp1,#abctcp2 {
  height: 3.93rem;
  /* border-top: 2px solid #E5E5E5 ; */
  padding-top: .72rem;
  text-align: left;
  box-sizing: border-box;
  overflow: hidden;
}

#abctcp1 {
  /* background: yellow; */
  border-top: .02rem solid #E5E5E5;
  }
#abctcp1 .el-col div, #abctcp2 .el-col div {
  font-size: .24rem;
  font-weight: 800;
  color: #333333;
  margin-bottom: .43rem;
}
#abctcp1 label, #abctcp2 label{
  width: 3.13rem;
  font-size: .18rem;
  font-weight: 800;
  color: #4D4D4D;
  line-height: .3rem;
}

.abctlocal {
  width: .25rem;
  height: .32rem;
  vertical-align: middle;
  margin-right: .13rem;
}

#abcthost {
  margin-top: .59rem;
  text-align: left;
  margin-bottom: .66rem;
}
#abcthost div {
  font-size: .3rem;
  font-weight: bold;
  color: #1A1B1E;
  margin-bottom: .39rem;
}
#abcthost label {
  display: block;
  font-size: .2rem;
  font-weight: bold;
  color: #4D4D4D;
  margin-bottom: .24rem;
}
#abalb img{
  border-radius: .3rem;
  margin: 0;
  padding: 0;
}
#abalb .el-col:nth-child(1) {
  text-align: right;
}
#abalb .el-col:nth-child(2) {
  text-align: left;
}
#abalb .el-col:nth-child(1) img {
  width: 6.2rem;
}
#abalb .el-col:nth-child(2) img {
  height: 3rem;
  margin-left: .26rem;
}
#abalb .el-col:nth-child(2) img:nth-child(2) {
  margin-top: .23rem;
}
#abcttt {
  font-size: .48rem;
  font-weight: bold;
  color: #1A1B1E;
  margin: .82rem 0 .81rem 0;
  font-weight: bold;

}
#abctmap div {
  font-size: .50rem;
  font-weight: bold;
  color: #1A1B1E;
  margin: .72rem 0 .68rem 0;
}
#abctmap img {
  width: 12.22rem;
  margin: 0;
}
#abcompany{
  background: white;
  text-align: center;
  margin: 0 auto;
  padding-bottom: 1.5rem;
}
#abcontact {
  background: white;
  text-align: center;
  width: 14.61rem;
  margin: 0 auto;
  padding-bottom: 1.5rem;
}
#abcontact {
  width: 12.41rem !important;
}
#abhead {
  height: 3.64rem;
  background-image: url('../assets/pic/head5.jpg');
  background-size: 100% 100%;
  color: white;
  padding-left: 4.51rem;
  box-sizing: border-box;
  overflow: hidden;
}
#abhead div:nth-child(1) {
  font-size: .48rem;
  font-weight: 800;
  margin-top: 1.15rem;
}
#abhead div:nth-child(2) {
  font-size: .14rem;
  font-weight: 500;
  margin-top: .12rem;
  width: 6.33rem;
}
#abcptt {
  font-size: .32rem;
  font-weight: 800;
  color: #2C2C2C;
  margin-top: .4rem;
}
#abcpct {
  font-size: .24rem;
  font-weight: 400;
  color: #666666;
  text-align: left;
  width: 13.53rem;
  line-height: 30px;
  margin: .7rem auto .99rem 2.71rem;
}
#abcppic {
  text-align: left;
  width: 14.61rem;
  margin: 0 auto;
}
#abcppic h5 img {
  margin: 0;
  padding: 0;
  height: 5.52rem;
}
#abcppic h5, #abcppic div {
  display: inline-block;
  margin: 0;
  vertical-align: top;
}
#abcppic div {
  padding-left: .49rem;
}
#abcppic div h4 {
  padding-top: .34rem;
  /* margin: 0 0 .38rem 0; */
  margin: 0;
}
#abcppic div h4 img {
  width: .6rem;
  height: .6rem;
  vertical-align: middle;
  margin-right: .24rem;
}
#abcppic label:nth-child(2) {
  display: inline-block;
  vertical-align: middle;
  width: 2.18rem;
  font-size: .24rem;
  font-weight: 500;
  color: #666666;
}
#abcppic label:nth-child(3) {
  display: inline-block;
  vertical-align: middle;
  font-size: .24rem;
  font-weight: 500;
  font-size: .62rem;
  font-weight: bold;
  color: #0080CB;
}

#abcard {
  margin-top: 1rem;
  width: 100%;
  padding-top: .12rem;
  height: 6.21rem;
  box-sizing: border-box;
  background-image: url('../assets/pic/about/bg.jpeg');
  background-size: 100% 100%;

}
#abcard #abcptt {
  color: white;
}
#abcard h5 {
  margin: .1rem auto .38rem auto;
  font-size: .24rem;
  font-weight: 350;
  color: #FFFFFF;
  width: 10.81rem;
}
#abcard h4 {
  display: inline-block;
  width: 3.11rem;
  height: 3.15rem;
  margin: 0 .3rem 0 .3rem;
  overflow: hidden;
  box-sizing: border-box;
}
#abcard img {
  width: 100%;
  height: 100%;
}
#abcard label {
  display: inline-block;
  width: 2.79rem;
  position: absolute;
  margin-left: .15rem;
  font-size: .28rem;
  font-weight: bold;
  color: #333333;
  margin-top: 2.15rem;
}
#abcard h4:nth-child(3) label {
  margin-top: 1.95rem !important;
}


#abcpcus {
  /* margin-top: 7.59rem; */
  height: 11.13rem;
  width: 14.61rem;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
}
#abcpcus h4 {
  font-size: 32px;
  font-weight: 800;
  color: #2C2C2C;
  margin: 1.33rem 0 0 0;
  padding: 0;
}
#abcpcus h5 {
  font-size: .24rem;
  font-weight: 500;
  color: #666666;
  padding: 0;
  margin: .14rem 0 1.45rem 0;
}
#abcpcus div {
  display: inline-block;
}
#abcpcus div:nth-child(3) {
  margin-right: 2.29rem;
}
#abcpcus label {
  display: block;
  margin-bottom: .7rem;
  font-size: .3rem;
  font-weight: 400;
  color: #666666;
}
#abcpcus img {
  height: 4.22rem;
}



</style>
<script>
// @ is an alias to /src
import {cmdata} from '@/assets/data/data'
require('@/assets/zt.css')

import mynav1_en from '@/components/mynav1_en'
import myfooter_en from '@/components/footer_en'




export default {
  components: {
    mynav1_en,myfooter_en
  },
  data () {
    var stype = this.$route.query.stype?this.$route.query.stype:'company'
    stype = stype?stype:'company'
    return {
      cards: [
        {label: 'IDC & CLOUD computing', pic: 'card1.png'},
        {label: 'Fintech', pic: 'card2.png'},
        {label: 'Smart Lighting', pic: 'card3.png'}
      ],
      ctpics: [
        {label: 'Founded in', value: '1993 ', pic: 'ctpic1.png'},
        {label: 'Listed in', value: '2007  ', pic: 'ctpic2.png'},
        {label: 'Total assets', value: '6 billion+ ', pic: 'ctpic3.png'},
        {label: 'Total shipments', value: '10 M+ ', pic: 'ctpic4.png'},
      ],
      addrs: [
        {
          city: 'Shenzhen',
          addr: 'Add: 4th Floor, Building 10, Phase II, Shenzhen Software Park, Keji Middle 2nd Road, High-tech Zone, Nanshan District, Shenzhen'
        },
        {
          city: 'Guangzhou',
          addr: 'Add: 39th Floor, Pearl River City Building, No. 15, Zhujiang West Road, Tianhe District, Guangzhou'
        },
        {
          city: 'Dongguan',
          addr: 'Add: No. 19, Shatian Road, Shijie Village, Shijie Town, Dongguan,Guangdong (China Telecom Cloud Computing Center)'
        }
      ],
      addrs1: [
        {
          city: 'Changsha',
          addr: 'Add: Management Committee of Economic Development Zone, No. 1 Tongxin Road, Wangcheng District, Changsha '
        },
        {
          city: 'Tongchuan ',
          addr: 'Add: Room V0050, Chuangye Building, Jinyang New City, Tianbao Road Street, Yaozhou District, Tongchuan, Shanxi Province'
        },
        {
          city: 'Chengdu',
          addr: 'Add: No. 06, 17th Floor, South Building, Sichuan Investment Building, No. 112, Tiantai Road,High-tech Zone, Chengdu, Sichuan Province'
        }
      ],
      
      cpcusdata: [
        {
          label: 'Powerful R&D Capability',
          img: require('@/assets/pic/about/cpcus0.png')
        },
        {
          label: 'Perfect Service',
          img: require('@/assets/pic/about/cpcus1.png')
        }
      ],
      stype : '',
      ovscroll: false,
      mdctdata: '',
      pdctdata: '',
      headdata: '',
      menudata: '',
      scrdist: 0,
      ftdata: {
        type: stype,
        lcallback: (stype) => {
          console.log(stype)
        }
      },
      nvdata: {
        sindex: 5,
        type: stype,
        lcallback: (stype) => {
          console.log(stype)
        }
      }
   
    }
  },
  watch: {
    "$route": {
      handler () {
        this.init()
      }
    }
  },
  computed: {
    lang () {
      return localStorage.lang
    }
  },
  methods: {
    backToTop () {
      window.scrollTo(0,0)
    },
    onPageScroll (dist) {
      this.ovscroll = dist>93?true:false
      if (dist - this.scrdist > 93) {
        this.scrdist = dist
      } else if (dist < this.scrdist) {
        this.scrdist = dist
      }
      if (dist>0) this.ismenu=false
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/20 + 'px'; /// 20
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem()

      var _this = this
      // var index = 1
      window.onscroll = function (e) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        _this.onPageScroll(scrollTop)
      }
    },

    init () {
      this.stype = this.$route.query.stype?this.$route.query.stype:'company'
      var tstr = type?type:'company'
      var item = cmdata[tstr]
    }
  },
  mounted () {
    this.initWindowEv()
    this.init()
  }
}
</script>
